import geoLocate from "//charcoalclothing.com.au/cdn/shop/t/224/assets/sl-module-ipwhois.js?v=132961642728865160981787026438"

const settings = {
  container: 'sl-module-shipping-threshold',
  progress_bar: 'FSTBar',
  message: 'FSTMessage',
  message_error: 'Please enter a target goal amount in the Theme Settings > Shipping Threshold'
};

const container = document.getElementById(settings.container);
let data;

const initData = async () => {
  const dataJson = container.nextElementSibling;

  if (!dataJson) return;

  data = JSON.parse(dataJson.innerText);
  data.location = await geoLocate();
}

const fetchCartData = async () => {
  try {
    const res = await fetch(theme.routes.cart ?? '/cart.js');
    const data = await res.json();

    if (res.ok) calculateThreshold(data)
  }
  catch(err) {
    console.log(err);
  }
}

const renderElements = async () => {
  const labelHTML = document.createElement('label')
  labelHTML.classList.add('visually-hidden')
  labelHTML.setAttribute('for', settings.progress_bar)
  labelHTML.textContent = 'Free shipping progress'

  const progressBarHTML = document.createElement('progress')
  progressBarHTML.id = settings.progress_bar
  progressBarHTML.setAttribute('max', 100)
  progressBarHTML.setAttribute('value', 0)

  const progressBarWrapper = document.createElement('div')
  progressBarWrapper.classList.add('fst-progress-bar-wrapper')
  progressBarWrapper.appendChild(progressBarHTML)

  const standardHTML = document.createElement('div')
  standardHTML.classList.add('fst-target', 'fst-standard')
  standardHTML.innerHTML = `<span class="dot"></span>`
  progressBarWrapper.appendChild(standardHTML)

  const expressHTML = document.createElement('div')
  expressHTML.classList.add('fst-target', 'fst-express')
  expressHTML.innerHTML = `<span class="dot"></span>`
  progressBarWrapper.appendChild(expressHTML)

  const messageHTML = document.createElement('div')
  messageHTML.id = settings.message
  messageHTML.classList.add('fst-message')

  container.appendChild(messageHTML);
  container.appendChild(labelHTML);
  container.appendChild(progressBarWrapper);
}

const renderExpressNotes = elem => {
  const express = data.targets.express[data.location.country_code] ?? data.targets.express.other

  if (!express) return;
  elem.innerHTML = `Free express shipping over $${express} storewide`;
}

const calculateThreshold = cartJson => {
  console.log(cartJson);
  console.log(data);

  const standard = data.targets.standard[data.location.country_code] ?? data.targets.standard.other
  const express = data.targets.express[data.location.country_code] ?? data.targets.express.other

  const target = express ? express : standard ? standard : null;
  const cart_total = (cartJson.total_price ? cartJson.total_price : cartJson.final_price) / 100;
  const progress_value = (cart_total / target) * 100;
  const remaining = target - cart_total;

  let message = '';

  if (target) {
    // Set value of progress bar
    if (progress_value >= 100){
      document.getElementById(settings.progress_bar).setAttribute('value', 100);
      document.getElementById(settings.progress_bar).parentElement.setAttribute('value', 100);
    }
    else {
      document.getElementById(settings.progress_bar).setAttribute('value', progress_value ? progress_value : 0);
      document.getElementById(settings.progress_bar).parentElement.setAttribute('value', progress_value ? progress_value : 0);
    }

    document.getElementById(settings.progress_bar).parentElement.style.setProperty('--standard', standard);
    document.getElementById(settings.progress_bar).parentElement.style.setProperty('--express', express);
    document.getElementById(settings.progress_bar).parentElement.style.setProperty('--standardPosition', (standard / express) * 100);

    message =
      remaining >= target ? data.messages.default.replace('[target]', `$${target}`) :
      remaining <= 0 ? data.messages.success : data.messages.ongoing.replace('[remaining]', `$${remaining ? remaining.toFixed(2) : target}`);
  }
  else
    message = settings.message_error

  document.getElementById(settings.progress_bar).parentElement.dataset.standard = standard ? true : false;
  document.getElementById(settings.progress_bar).parentElement.dataset.express = express ? true : false;

  // Display message
  document.getElementById(settings.message).innerHTML = message;
}

const init = async () => {
  if (!container) return;

  await initData();
  renderElements();
  fetchCartData();

  // Listeners for product added and cart updates
  ['cart:updated', 'ajaxProduct:added'].forEach(evt => {
    document.addEventListener(evt, fetchCartData, false)
  });

  // Add shipping express notes just below checkout button in cart
  const expressElem = document.querySelector('.js-shipping-threshold-express-notes');
  if (expressElem) renderExpressNotes(expressElem);
}

document.addEventListener('DOMContentLoaded', init, false);
